import configApi from '@/config.js';

export default function CreatePixelCode(puclicKey: string): string {
  const pixelCode: string =
    `%3C!-- Truffle pixel --%3E\n` +
    `%3Cscript type="application/javascript"%3E\n` +
    `!function (p,i,x,e,l,j,s) {` +
    `p[l] = p[l] || function (pixelId) {p[l].pixelId = pixelId};\n` +
    `j = i.createElement(x), s = i.getElementsByTagName(x)[0], j.async = 1, j.src = e, s.parentNode.insertBefore(j, s)` +
    `}(window, document, "script", "${configApi.INLINE_PIXEL_CDN}", "ttf")\n\n` +
    `ttf('${puclicKey}')\n` +
    `%3C/script%3E\n` +
    `%3C!-- Truffle pixel --%3E`;

  return decodeURIComponent(pixelCode);
}
